import { DayPicker } from "react-day-picker";
import { ChevronLeft, ChevronRight } from "lucide-react";

const TONES = {
  light: {
    caption_label: "font-display text-xl text-rc-ink",
    nav_button: "grid h-8 w-8 place-items-center rounded-full border border-rc-line text-rc-ink hover:border-rc-copper",
    head_cell: "w-10 font-mono-rc text-[10px] uppercase text-rc-muted",
    day: "h-10 w-10 rounded-full text-sm text-rc-ink transition-[background-color] hover:bg-rc-bg2",
    day_selected: "!bg-rc-copper !text-white",
    day_today: "font-semibold underline underline-offset-4",
    day_disabled: "!text-rc-faint line-through opacity-60 hover:bg-transparent cursor-not-allowed",
    day_outside: "opacity-40",
  },
  dark: {
    caption_label: "font-display text-xl text-[#F5EFE6]",
    nav_button: "grid h-8 w-8 place-items-center rounded-full border border-[#2E2A24] text-[#F5EFE6] hover:border-[#C4832B]",
    head_cell: "w-11 font-mono-rc text-[10px] uppercase text-zinc-400",
    day: "h-11 w-11 rounded-full text-sm text-[#F5EFE6] transition-[background-color] hover:bg-[#1A1A20]",
    day_selected: "!ring-2 !ring-[#F5EFE6]",
    day_today: "font-semibold underline underline-offset-4",
    day_disabled: "opacity-40",
    day_outside: "opacity-30",
  },
};

export const RcCalendar = ({ tone = "light", classNames = {}, ...props }) => {
  const t = TONES[tone];
  return (
    <DayPicker
      showOutsideDays
      classNames={{
        months: "flex flex-col", month: "space-y-4", caption: "relative flex items-center justify-center pt-1",
        nav: "flex items-center", nav_button_previous: "absolute left-0", nav_button_next: "absolute right-0",
        table: "w-full border-collapse", head_row: "flex", row: "mt-1 flex w-full", cell: "p-0 text-center",
        ...t, ...classNames,
      }}
      components={{ IconLeft: () => <ChevronLeft className="h-4 w-4" />, IconRight: () => <ChevronRight className="h-4 w-4" /> }}
      {...props}
    />
  );
};

export const toDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export const fromDay = (s) => {
  const [y, m, d] = s.split("-").map(Number);
  return new Date(y, m - 1, d);
};
